import React from "react"
import {
    Button,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"

import COPY_CONSTANTS from "~config/copy-constants"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly hideContinueButton?: boolean
    readonly handleContinueClick: () => void
    readonly isMobile?: boolean
    readonly isDisabled?: boolean
}

export default function PackageContinueButton({
    hideContinueButton,
    handleContinueClick,
    isMobile,
    isDisabled,
}: Props) {
    const styles = useStyles({ isMobile })

    if (hideContinueButton) {
        return null
    }

    const containerStyle = isMobile ? styles.mobileButtonContainer : {}

    return (
        <Box style={containerStyle}>
            <Button
                isDisabled={isDisabled}
                onClick={handleContinueClick}
                style={styles.continueButton}
                gradientEnabled
            >
                {COPY_CONSTANTS.CONTINUE}
            </Button>
        </Box>
    )
}

function useStyles({ isMobile }: { isMobile?: boolean }) {
    const colors = useColors()
    return componentStyles({
        mobileButtonContainer: {
            width: "100%",
            position: "fixed",
            bottom: "0",
            left: "0",
            zIndex: 10,
            height: "4.6rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderTop: `1px solid ${colors.border}`,
            backgroundColor: colors.bg,
        },
        continueButton: {
            width: isMobile ? "93%" : "100%",
        },
    })
}
